interface DividerProps {
  className?: string
}

export function Divider({ className = '' }: DividerProps) {
  return <div className={`w-full h-[2px] bg-gray-100 ${className}`} />
}
